export const API_URL = process.env.REACT_APP_API_BASE_URL;

export const IMG_USER_URL =
  process.env.REACT_APP_DIR_FILE + "/img/user/profile/";

export const API_URL_FILE = API_URL.split("/").slice(0, -2).join("/");

export const BASE_URL = process.env.REACT_APP_BASE_URL;

export const APPLICATION_IMG_URL =
  process.env.REACT_APP_DIR_FILE + "/img/application/";

export const FRONT_URL = process.env.REACT_APP_FRONT_URL;
